import moment from 'moment-business-days';
import addBusinessDays from 'date-fns/addBusinessDays';
/**
 * A residents earliest move in date window is determined by:
 *
 * - the available_from date set on the property
 * - if the property has existings tenants (the empty_from date)
 * - 1 business day from today
 *
 * - the latest the resident can move in, is the date from
 *   above + 3 weeks for UK properties. Any later, the resident
 *   must contact ops to arrange a move in date.
 */
export function earliestActualMoveInDate(propertyEmptyFromDate, propertyAvailableFrom) {
  const minStartDate = moment(addBusinessDays(new Date(), 1));

  if (propertyEmptyFromDate == null && propertyAvailableFrom == null) {
    return minStartDate;
  }

  const earliestPropertyEmptyMoveIn = earliestAvailableDate(propertyEmptyFromDate, minStartDate);
  const earliestPropertyAvailableMoveIn = earliestAvailableDate(propertyAvailableFrom, minStartDate);

  if (propertyEmptyFromDate == null && propertyAvailableFrom != null) {
    return earliestPropertyAvailableMoveIn;
  }

  if (propertyEmptyFromDate != null && propertyAvailableFrom == null) {
    return earliestPropertyEmptyMoveIn;
  }

  // return the later of the empty from or available from date
  if (earliestPropertyEmptyMoveIn >= earliestPropertyAvailableMoveIn) {
    return earliestPropertyEmptyMoveIn;
  }

  return earliestPropertyAvailableMoveIn;
}

function earliestAvailableDate(date, minStartDate) {
  if (date != null) {
    let notBeforeDate = moment(date, 'YYYY-MM-DD'); // date property available or empty from

    if (notBeforeDate > minStartDate) {
      return notBeforeDate;
    }

    return minStartDate;
  }
}
